var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTabletLogout = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 20,
  height: 30,
  viewBox: "0 0 20 30",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "6q85mqtjla",
  d: "M0 1.124L5.722 1.124 5.722 21.46 0 21.46z"
}), /*#__PURE__*/React.createElement("path", {
  id: "04o0w15jhc",
  d: "M0.006 1.122L12.633 1.122 12.633 28.696 0.006 28.696z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-38.000000, -302.000000) translate(38.000000, 302.000000) translate(0.000000, 4.095652)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "h0qr8413eb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#6q85mqtjla"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#C1C7D0",
  d: "M5.722 19.504H2.164l-.208-.208V3.288l.208-.207h3.558V1.124H2.164C.969 1.126 0 2.094 0 3.288v16.008c0 1.195.969 2.164 2.164 2.164h3.558v-1.956z",
  mask: "url(#h0qr8413eb)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-38.000000, -302.000000) translate(38.000000, 302.000000) translate(6.521739, 0.182609)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "6f8qohb9vd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#04o0w15jhc"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#C1C7D0",
  d: "M10.676 21.913l-.104.183-8.309 4.617-.104.026-.105-.026-.09-.182V3.287l.09-.183.105-.026.104.026 8.309 4.618.104.182v14.01zm.835-15.9L3.215 1.396c-.326-.183-.691-.274-1.056-.274-.378 0-.757.104-1.096.3C.424 1.813.007 2.492.007 3.248v23.283c-.013.77.404 1.473 1.056 1.865.34.195.718.3 1.096.3.365 0 .73-.092 1.056-.274l8.296-4.618c.691-.378 1.122-1.095 1.122-1.89V7.903c0-.795-.43-1.513-1.122-1.89z",
  mask: "url(#6f8qohb9vd)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#C1C7D0",
  d: "M12.046 14.896c-.014.287-.04.56-.105.822-.065.247-.13.47-.326.69-.117.144-.339.327-.652.327-.326 0-.548-.183-.665-.326-.13-.144-.196-.3-.261-.457-.105-.313-.157-.665-.157-1.056 0-.3.026-.574.092-.822.065-.248.143-.47.326-.691.117-.144.339-.326.665-.326.313 0 .535.182.652.326.13.143.196.3.261.456.104.313.156.665.17 1.057",
  transform: "translate(-38.000000, -302.000000) translate(38.000000, 302.000000)"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTabletLogout);
export default ForwardRef;